module.exports = __webpack_public_path__ + "static/AktivGrotesk-Regular-8a3e2bf7021dc1ac76fdc0e1b8c165cc.woff2";